import {useCategoriesMenuStore} from '~/stores/categoriesMenuStore';
import {useCpNavigateToParams} from '~/composables/useCpNavigateToParams';

export const useCategoriesMenu = () => {
    const store = useCategoriesMenuStore();
    const selectCategory = (id: string, byName = false) => {
        if (byName && store.getFlatCategories) {
            const flatCategories = store.getFlatCategories;
            id = Object.keys(flatCategories).find((a: any) => flatCategories?.[a].title
                .replaceAll('/', '')
                .replaceAll('  ', ' ')
                .replaceAll('-', ' ')
                .replaceAll('+', ' ') === id) ?? '';
        }
        const category = store.getFlatCategories?.[id];
        if (!category) {
            return;
        }
        if (!category.hasSubCategories) {
            // routeStore.setLoader(true)
            // const result = await useCpLink(category.link)
            const result = useCpNavigateToParams('catalog', category.link);
            navigateTo(result);
        }
        const tree = findPath(id);
        // Set in the store the new tree
        store.setActiveCategoryTree(tree);
    };
    // Get array of parent categories for a given category id
    const findPath = (id: string) => {
        const path = [];
        let current = store.getFlatCategories?.[id];
        while (current) {
            path.unshift(current);
            if (!current.parentId) {
                break;
            }
            current = store.getFlatCategories?.[current.parentId];
        }
        return path;
    };

    return {selectCategory};
};
